import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import ObrasTable from '../components/obras/ObrasTable';

export const Obras: React.FC = () => {
  return (
    <Layout>
      <Box sx={{ p: 2 }}>
        <Breadcrumbs sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/" color="inherit">
            Inicio
          </Link>
          <Typography color="text.primary">Obras</Typography>
        </Breadcrumbs>

        <Typography variant="h4" component="h1" gutterBottom>
          Gestión de Obras
        </Typography>

        <ObrasTable />
      </Box>
    </Layout>
  );
};

export default Obras;